import "./styles.scss";

export default function feedbackButton({ root, domain = "", action = "/", classes = "" }) {
  if (!root) return;

  const form = document.createElement("form");
  form.setAttribute("method", "POST");
  form.setAttribute("action", action);
  form.className = `pie-feedback-button ${classes}`
  form.innerHTML = `
    <input name="url" type="hidden" value="${window.location.pathname}" />
    <button type="submit">
      <svg class="icon sm white" aria-hidden="true">
        <use href="${domain}templates/pistacja/images/icons/icons.svg#ui-info"></use>
      </svg>
      <span>${pie_i18n.PIE_JS_FEEDBACK_BUTTON_LABEL}</span>
    </button>
  `;
  root.appendChild(form);
}
